import React from 'react'

import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'
import { PriceWithImagesPopoverRenderer } from '@app/components/renderers/PriceWithImagesPopoverRenderer'
import { AbnormalStateStatusTagRender } from '@app/components/renderers'
import { priceDifferenceRender } from '@app/entities/priceDifference'

import { CustomEllipsis } from '@app/constants/customEllipsis'
import { ColumnWidth } from '@app/constants/columnWidth'

import { columnTitleMap, columnSettingSchema } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ProcessingResultsDataSource } from '../types'

const getOptions = (): Array<Column<ProcessingResultsDataSource>> => {
  const columnsKeys = Object.keys(columnTitleMap).filter(
    key => !['regularPriceCompetitor', 'abnormalState', 'promoPriceCompetitor', 'priceDifference'].includes(key)
  ) as Array<keyof ProcessingResultsDataSource>

  return columnsKeys.map(key => {
    const column: Column<ProcessingResultsDataSource> = {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key]),
      ...ColumnWidth,
      ...columnSettingSchema[key]
    }

    return column
  })
}

export const getColumns = (): Array<Column<ProcessingResultsDataSource>> => {
  return getColumnsFromMap<ProcessingResultsDataSource>({
    columnTitleMap,
    options: [
      ...getOptions(),
      {
        key: 'regularPriceCompetitor',
        sorter: (a, b) => sorterDispatcher(a.regularPriceCompetitor?.price, b.regularPriceCompetitor?.price),
        render: (_, { regularPriceCompetitor }) => (
          <PriceWithImagesPopoverRenderer previewPrice={ regularPriceCompetitor } />
        )
      },
      {
        key: 'abnormalState',
        sorter: (a, b) => sorterDispatcher(a.abnormalState, b.abnormalState),
        render: (_, { abnormalState }) => <AbnormalStateStatusTagRender status={ abnormalState } />
      },
      {
        key: 'promoPriceCompetitor',
        sorter: (a, b) => sorterDispatcher(a.promoPriceCompetitor?.price, b.promoPriceCompetitor?.price),
        render: (_, { promoPriceCompetitor }) => <PriceWithImagesPopoverRenderer previewPrice={ promoPriceCompetitor } />
      },
      {
        key: 'priceDifference',
        sorter: (a, b) => sorterDispatcher(a.priceDifference, b.priceDifference),
        render: priceDifferenceRender
      }
    ]
  })
}
